import React from 'react'

export const HomeInmersys = () => {
    return (
        <div className='w-full h-full flex justify-center items-center bg-[#cecece]'>
            <p className='text-2xl text-black'>
                Selecciona un proyecto del menu
            </p>
        </div>
    )
}

export default HomeInmersys
